<template>
  <span class="fa-stack custom-sort-stack cursor-pointer">
    <FontAwesomeIcon :icon="faSortUp" class="fa-stack-1x sort-up" />
    <FontAwesomeIcon :icon="faSortDown" class="fa-stack-1x sort-down" />
  </span>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons'
</script>

<style scoped>
.custom-sort-stack {
  width: 1em;
}
.custom-sort-stack .fa-stack-1x {
  left: 0;
  width: 100%;
  text-align: center;
  color: var(--icon-default);
  font-size: 12px;
}
</style>
